const e=e=>`mlh-${e}`;export{e as getMobileLineHeightClassName};
//# sourceMappingURL=get-mobile-line-height-class-name.js.map